import { LockerDetailsPageHeaderProps } from '../../../../ui/components/pure/page-headers/details/locker-details/locker-details-page-header.component';
import { lockerSizeToLockerIconMap } from '../../logic/locker-ui.constants';
import { LockerDetailsActions, makeDefineLockerDetailsActions } from '../actions/locker-details.actions';
import { Locker } from '../../models/locker.model';
import { Space } from '../../models/space.model';
import { HubDetails } from '../../models/hub-details.model';
import { TowerDetails } from '../../models/tower-details.model';
import { SectionDetails } from '../../models/section-details.model';
import { HubDto } from '@groundfloor-platform/mgmt-service-g-sdk/dist/commonjs/models';
import { mapTransactionTypesToIcons } from '../../../deliveries/maps/kiosk-transaction-types-to-icons.map';

export function makeLockerDetailsHeaderProps(
  projectID: string,
  locker: Locker,
  hubDetails: HubDetails,
  hub: HubDto,
  tower: TowerDetails | undefined,
  hasInternalUIFeatures: boolean,
  transactionTypes: string[] | undefined,
  setAction: (action: LockerDetailsActions) => void
): LockerDetailsPageHeaderProps {
  return {
    title: `${locker.isKiosk ? 'Kiosk' : 'Locker'} #${locker.name}`,
    subtitle: `${hubDetails.name}${tower ? ' > Tower ' + tower.name : ''}`,
    status: {
      label: locker.status,
      bgColor: locker.statusColor,
      Icon: locker.statusIcon
    },
    ...(locker.isKiosk !== true && {
      availability: {
        label: locker.availability,
        bgColor: locker.availabilityBadgeColor.bgColor,
        color: locker.availabilityBadgeColor.color,
        Icon: locker.availabilityIcon
      }
    }),
    size: {
      label: locker.sizeDescription,
      Icon: lockerSizeToLockerIconMap(locker.isKiosk, locker.sizeName)
    },
    isConsideredLow: locker.isConsideredLow,
    transactionTypes: transactionTypes ? mapTransactionTypesToIcons(transactionTypes) : [],
    reservedForRecipients: locker.reservedForRecipients.map((r) => r.name),
    actions: makeDefineLockerDetailsActions(
      projectID,
      locker.id,
      hubDetails,
      hub,
      hasInternalUIFeatures,
      true
    )(setAction)
  };
}

export function makeSpaceDetailsHeaderProps(
  projectID: string,
  space: Space,
  hubDetails: HubDetails,
  hub: HubDto,
  section: SectionDetails | undefined,
  hasInternalUIFeatures: boolean,
  transactionTypes: string[] | undefined,
  setAction: (action: LockerDetailsActions) => void
): LockerDetailsPageHeaderProps {
  return {
    title: `${space.isKiosk ? 'Kiosk' : 'Space'} #${space.name}`,
    subtitle: `${hubDetails.name}${section ? ' > Section ' + section.name : ''}`,
    status: {
      label: space.status,
      bgColor: space.statusColor,
      Icon: space.statusIcon
    },
    ...(space.isKiosk !== true && {
      availability: {
        label: space.availability,
        bgColor: space.availabilityBadgeColor.bgColor,
        color: space.availabilityBadgeColor.color,
        Icon: space.availabilityIcon
      }
    }),
    size: {
      label: 'Space',
      Icon: space.icon
    },
    transactionTypes: transactionTypes ? mapTransactionTypesToIcons(transactionTypes) : [],
    reservedForRecipients: space.reservedForRecipients.map((r) => r.name),
    actions: makeDefineLockerDetailsActions(
      projectID,
      space.id,
      hubDetails,
      hub,
      hasInternalUIFeatures,
      true
    )(setAction)
  };
}
